/*
 * Copyright 2025 coze-dev Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

export type Int64 = string | number;

export enum IntelligenceTaskActionEventMsgEventType {
  TaskSuccess = 1,
  TaskFailed = 2,
  TaskCanceled = 3,
}

export enum IntelligenceTaskActionType {
  Copy = 1,
  Move = 2,
  Publish = 3,
}

export enum IntelligenceTaskEntityLocationType {
  Project = 1,
  Space = 2,
  Online = 3,
  Template = 4,
  Agent = 5,
}

export enum IntelligenceTaskEntityType {
  Plugin = 1,
  Workflow = 2,
  Imageflow = 3,
  Knowledge = 4,
  UI = 5,
  Project = 6,
  Database = 7,
  Variable = 8,
  Trigger = 9,
  Agent = 10,
  Prompt = 11,
  Shortcut = 12,
}

export enum IntelligenceTaskStatus {
  Success = 1,
  Processing = 2,
  Failed = 3,
  Canceled = 4,
}

export enum IntelligenceTaskType {
  /** 复制项目内的资源到同项目 */
  CopyResourceInProject = 1,
  /** 复制项目资源到Library */
  CopyProjectResourceToLibrary = 2,
  /** 移动项目资源到Library */
  MoveProjectResourceToLibrary = 3,
  /** 复制Library资源到项目 */
  CopyLibraryResourceToProject = 4,
  /** 复制项目 */
  CopyProject = 5,
  /** 项目发布到渠道 */
  PublishProject = 6,
  /** 复制项目模板 */
  CopyTemplateToProject = 7,
  /** 项目发布到模板 */
  PublishProjectTemplate = 8,
  /** 项目模版上架 */
  LaunchProjectTemplate = 9,
  /** 项目存档 */
  ArchiveProject = 10,
  /** 项目回滚 */
  RollbackProject = 11,
  /** 单个资源跨空间复制 */
  CrossSpaceCopy = 12,
  /** 项目跨空间复制 */
  CrossSpaceCopyProject = 13,
}
/* eslint-enable */
